import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { DelegationReportdata,RecentDelegatee } from  './delegation-reports';
import { Globals } from 'src/app/_utlity/globals';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
import { DelegationReportFiltersdata } from './delegation-report-filter';
import { AppId, SAPID } from 'src/app/_shared/common/global-variables';


@Injectable({
  providedIn: 'root'
})
export class DelegationReportsService {

  private RequesterSAPId = this.global.UserLoggedInSAPID;
  constructor(private global: GlobalService,private httpClient:HttpClient,private globals:Globals,private globalServices: GlobalService) { }

  getdeligationurl='DelegationReport/GetDelegationRequestData';
  deligationurl='DelegationReport/DownloadDelegationRequestData';
 
  localhosturl = this.globalServices.baseUrl;
  localhostsuburl1 = 'DelegationReport/Getapplicationlist';
  localhostsuburl2 = 'DelegationReport/Getstatus';
  localhostsuburl3 = 'DelegationReport/GetRoles/';
  fetchEmployeeSuggestionsUrl='DelegationRequest/SearchEmployee/';
  

appId:AppId;

getDelegationRequestdata(filtervalues : DelegationReportdata):Observable<DelegationReportdata[]>
{
  const httpHeaders = new HttpHeaders({   
         });
return this.httpClient.post<DelegationReportdata[]>(this.localhosturl + this.getdeligationurl , filtervalues , {headers:httpHeaders})
}

downloadDelegationRequestdata(filtervalues : DelegationReportdata):Observable<DelegationReportdata[]>
{
  const httpHeaders = new HttpHeaders({
         });
return this.httpClient.post<DelegationReportdata[]>(this.localhosturl + this.deligationurl , filtervalues , {headers:httpHeaders})

}


getApplicationFilterData():Observable<DelegationReportFiltersdata[]>
{
  const httpHeaders = new HttpHeaders({
         });
  return this.httpClient.get<DelegationReportFiltersdata[]>(this.localhosturl + this.localhostsuburl1 , {headers:httpHeaders})
}

getStatusFilterData():Observable<DelegationReportFiltersdata[]>
{
  const httpHeaders = new HttpHeaders({
         });
  return this.httpClient.get<DelegationReportFiltersdata[]>(this.localhosturl + this.localhostsuburl2 , {headers:httpHeaders})
}

getCDSRolesFilterData(AppId :number ):Observable<DelegationReportFiltersdata[]>
{
  const appId = <AppId>
  {
    ReqAppid:AppId
  }
  const httpHeaders = new HttpHeaders({   
         });
  return this.httpClient.post<DelegationReportFiltersdata[]>(this.localhosturl + this.localhostsuburl3, appId, {headers:httpHeaders})
}

handleError(err: HttpErrorResponse){
  let errorMessage='';
  if (err.error instanceof ErrorEvent) 
  {
    errorMessage = `An error occurred : ${err.error.message}`;
  }
  else 
  {
    errorMessage=`Server returned code: ${err.status}, errorMessage is : ${err.message}`;
  }
  //console.error(errorMessage);
  return  throwError(errorMessage);
}

fetchEmployeeSuggestions(inputValue:string):Observable<RecentDelegatee[]>
{
  const searchSapId=<SAPID>
  {
    ReqSAPID:inputValue
  }  
  const httpHeaders = new HttpHeaders({
         });
    return this.httpClient.post<RecentDelegatee[]>(this.localhosturl+ this.fetchEmployeeSuggestionsUrl, searchSapId , {headers:httpHeaders});
}

}
